import { ValidatorFn, Validators } from '@angular/forms';
import { validateSecurePassword } from './password.validator';
import { validateCustomEmail } from './custom-email.validator';

export class CustomValidators extends Validators {
  static securePassword: ValidatorFn = validateSecurePassword;
  static customEmail: ValidatorFn = validateCustomEmail;
}
